import React, { useState, useEffect, useCallback } from 'react';
import SearchBox from '../components/searchbox.js';
import API from '../common/api.js';

function AutomationsPage({allCaseNumbers}) {
    const [loading, setLoading] = useState(true);
    const [invocations, setInvocations] = useState([]);
    const [oldest, setOldest] = useState(null);
    const [hasMore, setHasMore] = useState(true);
    const [errMsg, setErrMsg] = useState(null);
    const [initialSearchValue, setInitialSearchValue] = useState("");

    const loadInitialData = useCallback(async () => {
        const data = await API.getAutomations();
        if (data) {
            setInvocations(data.invocations);
            setOldest(data.oldest);
            setHasMore(true);
            setLoading(false);
        } else {
            setErrMsg("Unable to load data from server");
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadInitialData();
    }, [loadInitialData]);

    async function onLoadMoreClicked() {
        setLoading(true);
        const data = await API.getAutomationsOlderThan(oldest);
        if (data) {
            if (data.invocations.length === 0) {
                setLoading(false);
                setHasMore(false);
            } else {
                const newInvocations = invocations.concat(data.invocations);
                setInvocations(newInvocations);
                setOldest(data.oldest);
                setLoading(false);
            }
        } else {
            setErrMsg("Failed to load more messages from server");
            setLoading(false);
        }
    }

    async function onSearchBoxCommit(caseNumber) {
        if (caseNumber.length === 0) {
            setInitialSearchValue("");
            await loadInitialData();
        } else {
            setLoading(true);
            setHasMore(false);
            setInvocations([]);
            setInitialSearchValue(caseNumber);
            const data = await API.getAutomationsForCase(caseNumber);
            if (data) {
                setInvocations(data.invocations);
                setOldest(data.oldest);
                setLoading(false);
                setHasMore(false);
            } else {
                setErrMsg("Unable to load data from server");
                setLoading(false);
            }
        }
    }

    const rows = invocations.map((invocation, inx) => 
        <tr key={inx}>
            <td>{invocation.timestamp}</td>
            <td className="hoverparent">{invocation.case_number} <button className="ui basic mini icon button showwhenparenthovered" onClick={() => onSearchBoxCommit(invocation.case_number)}><i className="search icon"></i></button></td>
            <td>{invocation.name}</td>
            <td>{invocation.eventname}</td>
        </tr>
    );

    let btnclass = "ui black bottom attached button";
    if (loading) {
        btnclass = `${btnclass} loading disabled`;
    }
    if (!hasMore) {
        btnclass = `${btnclass} disabled`;
    }
    const loadMoreButton = <div className={btnclass} tabIndex="0" onClick={onLoadMoreClicked}>{hasMore ? "Load more" : "That's all folks!"}</div>;

    const errmsgEl = errMsg ? <div className="ui error message">{errMsg}</div> : null;

    return (
        <div style={{paddingTop: 10, height: '100%', overflowY: 'auto', paddingRight: 10, paddingBottom: 10}}>
            <SearchBox allPossibleValues={allCaseNumbers} onCommit={onSearchBoxCommit} initialValue={initialSearchValue}/>
            <table className="ui very basic striped table">
                <thead>
                    <tr>
                        <th>Timestamp</th>
                        <th>Matter</th>
                        <th>Automation</th>
                        <th>Event</th>
                    </tr>
                </thead>
                {errmsgEl}
                <tbody>
                    {rows}
                </tbody>
            </table>
            {loadMoreButton}
        </div>
    );
}

export default AutomationsPage;
